import CorpOnlineSales from './OnlineSales/index.vue'

export default [
  { path: '/corp/onlinesales', component: CorpOnlineSales, meta: { auth: true }, }
]